import { ParametersModelAPI } from '../../../../models';
import { getparametersApplicationAdapter } from '../../Adapters/application-parameters/ApplicationParameter.adapter';
import { requests } from '../apiAgent';

export const ApplicationParametersAPI = {
    getApplicationParameters: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/application-parameters')
            .then((response: ParametersModelAPI[]) =>
                getparametersApplicationAdapter(response)
            );
    },
};
